import Vue from 'vue'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isToday from 'dayjs/plugin/isToday'
import isoWeek from 'dayjs/plugin/isoWeek'
import relative from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import updateLocale from 'dayjs/plugin/updateLocale'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/hu'

dayjs.extend(localizedFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isToday)
dayjs.extend(isoWeek)
dayjs.extend(relative)
dayjs.extend(duration)
dayjs.extend(utc)
// tasks#202: offset-less binlog datetimes are read in the application timezone
dayjs.extend(timezone)
dayjs.extend(updateLocale)

// British dates everywhere (tasks#211): "L" = "6 Nov 2026", day before month, never the US "Nov 6"
for (const name of ['en', 'en-gb']) {
    dayjs.updateLocale(name, {
        formats: {
            ...dayjs.Ls[name].formats,
            L: 'D MMM YYYY',
        },
    })
}

// from https://github.com/Juceztp/vue-dayjs
Object.defineProperties(Vue.prototype, {
    $date: {
        get() {
            return dayjs
        },
    },
    //TODO find a better solution
    $generalizeDate: {
        value: (value) => value?.split('+')?.[0].split('T')?.join(' '),
        writable: false,
    },
})

export default dayjs
